export const VWO_EVENT_PREFIX = "gtm.";
export const VWO_UUID_COOKIE = "_vwo_uuid";
export const VWO_UUID_V2_COOKIE = "_vwo_uuid_v2";
